/* src/app/fuel/pages/fuel-prices-new/fuel-prices-new.component.scss */
/*# sourceMappingURL=fuel-prices-new.component.css.map */
